module.exports = __webpack_public_path__ + "assets/img/travel-day25.2248005c.png";